<template>
  <div class="page-container demand-details">
    <b-container>
      <div style="text-align: center" v-if="showPageLoader">
        <b-spinner
          style="width: 3rem; height: 3rem"
          label="Large Spinner"
        ></b-spinner>
      </div>

      <div
        v-if="!showPageLoader && Object.keys(demandDetails.value).length > 0"
      >
        <div class="ft-notification">
          <status-banner :data="demandDetails.value" />
          <!-- <b-row v-if="bidPlaced">
            <div class="alert-col">
              <b-alert show variant="success" class="ft-alert">
                <b-icon icon="check" aria-hidden="true"></b-icon>

                <div class="alert-content">
                  <p>{{ $t("message.bidPlaced") }}・{{ demandDetails.value.truck_size }}
                    <span class="ft-route-time small-text grey-text-1 pdl-27">{{
                        demandDetails.value.supplier_name
                      }} ({{ '+91 ' + demandDetails.value.contact }})</span>
                    <span class="small-text grey-text-1 pdl-27">{{ $t('message.bidPlaceOn') }} {{ bidPlacedAt }}</span>
                  </p>
                </div>
              </b-alert>
            </div>
          </b-row>

          <b-row
              v-if="demandDetails.value && (demandDetails.value.status === 'CLOSED' || demandDetails.value.status === 'EXPIRED')">
            <div class="alert-col">
              <b-alert show variant="danger" class="ft-alert">
                <b-icon icon="exclamation-circle"></b-icon>
                <div class="alert-content">
                  <p>{{ $t("message.closedBid") }}
                    <span class="ft-route-time small-text grey-text-1 pdl-27">{{
                        demandDetails.value.supplier_name
                      }} ({{ '+91 ' + demandDetails.value.contact }})</span>
                    <span class="pdl-27"><add-supplier-modal /></span>
                  </p>
                </div>
              </b-alert>
            </div>
          </b-row>

          <b-row
              v-if="(demandDetails.value && (demandDetails.value.status === 'OPEN' || demandDetails.value.status === 'PLACED')) && !bidPlaced">
            <div class="alert-col">
              <b-alert show variant="warning" class="ft-alert">
                <icon-base icon-name="bid" width="16" height="16" viewbox="0 0 24 22">
                  <icon-bid/>
                </icon-base>
                <div class="alert-content">
                  <p>{{ $t("message.bidFor") }}
                    <span class="ft-route-time small-text grey-text-1 pdl-27">{{
                        demandDetails.value.supplier_name
                      }} ({{ '+91 ' + demandDetails.value.contact }})</span>
                    <span class="small-text grey-text-1 pdl-27"> {{
                        demandDetails.value.status == 'PLACED' ? bidPlacedAt + ' &bull; ' : ''
                      }}  <add-supplier-modal :demand-details="demandDetails.value"/></span>
                  </p>
                </div>
              </b-alert>
            </div>
          </b-row> -->
        </div>
        <div class="demand-details-content">
          <b-row>
            <b-col cols="12" class="ft-route-details">
              <h4 class="ft-route">
                {{ demandDetails.value.origin }} -
                {{ demandDetails.value.destination }}
              </h4>
              <!-- <p class="ft-route-time small-text grey-text-1">Reporting {{reportingTime}}</p> -->
            </b-col>
          </b-row>

          <b-row class="vehicle-material-details">
            <b-col cols="6">
              <h6 class="ft-vehicle">
                <icon-base icon-name="truck" width="18" height="16">
                  <icon-truck />
                </icon-base>
                <span>{{ vehicleDetail }}</span>
              </h6>
              <span class="small-text grey-text-1 pdl-34">{{
                demandDetails.value.truck_size
              }}</span>
            </b-col>
            <b-col cols="6" v-if="demandDetails.value.material">
              <h6 class="ft-material">
                <icon-base icon-name="material" width="15" height="20">
                  <icon-material />
                </icon-base>
                <span>{{ demandDetails.value.material }}</span>
              </h6>
            </b-col>
          </b-row>

          <b-row
            class="demand-controls"
            v-if="
              (demandDetails.value &&
                demandDetails.value.demand_status_details.status === 'OPEN' &&
                demandDetails.value.demand_status_details.rate == null &&
                demandDetails.value.demand_status_details.trucks_supplied ==
                  null) ||
              editMode
            "
          >
            <b-col cols="5" style="padding-right: 1px">
              <b-form-group v-if="demandDetails.value.trucks_required > 1">
                <label for="vehicle-qty" class="d-block">{{
                  $t("message.biddingForLabel")
                }}</label>

                <b-form-spinbutton
                  id="vehicle-qty"
                  v-model="vehicle_qty"
                  min="1"
                  :max="demandDetails.value.trucks_required"
                  class="mb-2 btn-spinner"
                ></b-form-spinbutton>
              </b-form-group>
              <b-form-group v-if="demandDetails.value.trucks_required == 1">
                <label for="vehicle-qty" class="d-block">{{
                  $t("message.biddingFor")
                }}</label>
                <div @click="onClickInputQty">
                  <b-form-input
                    class="vehicle-qty-readonly"
                    id="vehicle-qty"
                    :value="vehicle_qty"
                    disabled
                    style="text-align: center"
                  ></b-form-input>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="2" style="text-align: center; margin-top: 35px">
              <span class="">
                <icon-base icon-name="close" width="20" height="14"
                  ><icon-close
                /></icon-base>
              </span>
            </b-col>
            <b-col cols="5" style="padding-left: 1px">
              <b-form-group class="mb-0">
                <label for="vehicle-rate" class="d-block">{{
                  $t("message.vehicleRateLabel")
                }}</label>
                <b-form-input
                  id="vehicle-rate"
                  v-model="biddingprice"
                  @blur="isInputActive = false"
                  @focus="isInputActive = true"
                  @input="$v.rate_received.$touch()"
                  :state="
                    $v.rate_received.$dirty ? !$v.rate_received.$error : null
                  "
                  :disabled="editMode"
                  placeholder=""
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col
              v-if="$v.rate_received.$error"
              class="feedback-text error-text"
              cols="12"
            >
              <span>{{ $t("message.invalidBidAmount") }}</span>
            </b-col>
            <b-col
              v-if="rate_received >= '1000'"
              class="feedback-text valid-text"
              cols="12"
            >
              <span>{{ $t("message.validAmountText") }}</span>
            </b-col>

            <b-col cols="12" v-if="editMode">
              <b-alert show style="background-color: rgba(230, 242, 255, 255)">
                <b-row>
                  <b-col cols="5"
                    ><p class="vertical-center">Edit Truck Rate:</p></b-col
                  >
                  <b-col cols="7">
                    <b-button-group>
                      <b-button
                        class="btn ft-btn"
                        variant="light"
                        :disabled="
                          rate_received <= 0 ||
                          rate_received - stepperValue < 1000
                        "
                        @click="handleChangePrice('decrement')"
                        >- 500
                      </b-button>
                      <b-button
                        class="btn ft-btn"
                        variant="light"
                        :disabled="
                          rate_received + stepperValue >
                          demandDetails.value.demand_status_details.rate
                        "
                        @click="handleChangePrice('increment')"
                        >+ 500
                      </b-button>
                    </b-button-group>
                  </b-col>
                </b-row>
              </b-alert>
            </b-col>

            <b-col cols="4" v-if="editMode">
              <div class="">
                <b-button
                  class="ft-btn"
                  block
                  variant="light"
                  @click="cancelEdit"
                >
                  {{ $t("message.modalCancelBtnText") }}
                </b-button>
              </div>
            </b-col>

            <b-col cols="8" v-if="editMode">
              <div class="place-bid-btn">
                <b-button
                  class="ft-btn"
                  :disabled="
                    showPlaceBidLoader ||
                    $v.$invalid ||
                    (editMode &&
                      rate_received >=
                        demandDetails.value.demand_status_details.rate)
                  "
                  block
                  variant="primary"
                  @click="submitBid"
                >
                  <b-spinner
                    v-if="showPlaceBidLoader"
                    small
                    label="Small Spinner"
                  ></b-spinner>
                  {{ rate_received > 0 ? totalPrice + " &bull; " : "" }}
                  {{ $t("message.updateBidBtnText") }}
                </b-button>
              </div>
            </b-col>
            <b-col
              v-if="
                editMode &&
                rate_received >= demandDetails.value.demand_status_details.rate
              "
              class="feedback-text error-text"
              cols="12"
              style="margin-top: 0.5rem"
            >
              <span>{{ $t("message.editBidErrorText") }}</span>
            </b-col>
            <b-col cols="12" v-if="!editMode">
              <div class="place-bid-btn">
                <b-button
                  class="ft-btn"
                  :disabled="showPlaceBidLoader || $v.$invalid"
                  block
                  variant="primary"
                  @click="submitBid"
                >
                  <b-spinner
                    v-if="showPlaceBidLoader"
                    small
                    label="Small Spinner"
                  ></b-spinner>
                  {{ rate_received > 0 ? totalPrice + " &bull; " : "" }}
                  {{ $t("message.placeBidBtnText") }}
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>

    <!--  -->
    <b-container
      v-if="
        demandDetails.value.demand_status_details &&
        demandDetails.value.demand_status_details.is_edit_allowed &&
        !editMode
      "
    >
      <b-row>
        <b-col cols="12" style="margin-top: 1rem">
          <div class="place-bid-btn">
            <b-button
              class="ft-btn ft-btn-primary"
              block
              style="width: 100%; margin-right: 5%"
              @click="enableEditBidOption"
            >
              {{ rate_received > 0 ? totalPrice + " &bull; " : "" }}
              {{ $t("message.editBidBtnText") }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <b-container v-if="!editMode">
      <div style="border-top: 1px solid #ebebeb; margin-top: 10px">
        <b-row style="margin-top: 1rem">
          <b-col cols="12">
            <div class="place-bid-btn">
              <b-button
                class="ft-btn ft-btn-primary"
                block
                style="width: 100%; margin-right: 5%"
                @click="navigateToLoadMore"
              >
                {{
                  $t("message.exploreMoreLoadBtnText", [
                    demandDetails.value.load_market &&
                    demandDetails.value.load_market.open > 2
                      ? demandDetails.value.load_market.open +
                        demandDetails.value.load_market.preferred
                      : "",
                  ])
                }}
              </b-button>
            </div>
          </b-col>
        </b-row>
        <b-row
          style="
            margin-top: 1rem;
            border-top: 1px solid #ebebeb;
            margintop: 10px;
          "
        >
          <b-col cols="12">
            <p style="width: 100%; margin-top: 15px; color: #707070">
              {{ $t("message.truckAvailibilityText") }}
            </p>
            <div class="have-truck-btn">
              <b-button
                class="ft-btn"
                block
                variant="outline-secondary"
                style="width: 100%; margin-top: 15px"
                @click="truckAvailability"
              >
                <!-- <b-spinner v-if="showPlaceBidLoader" small label="Small Spinner"></b-spinner> -->
                {{ $t("message.truckAvailibility") }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import IconBase from "../components/IconBase.vue";
import IconTruck from "../components/icons/IconTruck.vue";
import IconMaterial from "../components/icons/IconMaterial.vue";
import IconClose from "../components/icons/IconClose.vue";
// import IconBid from '../components/icons/IconBid.vue'

import StatusBanner from "../components/StatusBanner.vue";
// import AddSupplierModal from '../components/AddSupplierModal.vue'

import { identify, MX_TRACK } from "../utils/Mixpanel.js";

const Hotjar = require("../utils/Hotjar.js");
import config from "../config/config.js";

import axios from "axios";
import moment from "moment";

import { required } from "vuelidate/lib/validators";

const rateGreaterThanZero = (value) => {
  return parseInt(value) >= 1000;
};

const API_BASE_URL = process.env.VUE_APP_API_GATEWAY_BASE_URL;

export default {
  name: "DemandDetails",
  components: {
    IconBase,
    IconTruck,
    IconMaterial,
    IconClose,
    // IconBid,
    // AddSupplierModal,
    StatusBanner,
  },
  data() {
    return {
      editMode: false,
      isInputActive: false,
      vehicle_qty: 0,
      rate_received: "",
      bidPlaced: false,
      showPageLoader: true,
      showPlaceBidLoader: false,
      demandDetails: {
        value: {},
        status: false,
      },
      stepperValue: 500,
      stepperCount: {
        up: 0,
        down: 0,
      },
    };
  },
  validations: {
    rate_received: {
      required,
      rateGreaterThanZero,
    },
  },
  watch: {
    $route(to, from) {
      if (to.params.id != from.params.id) {
        this.getDemadDetails();
        this.linkOpened();
      }
    },
  },
  mounted: function () {
    this.getDemadDetails();
    this.linkOpened();
    if (this.$route.query.action === "edit") {
      this.editMode = true;
    }
    const routeData = {
      routeName: this.$route.name,
      lng: this.$route.params.lang,
      demandId: this.$route.params.id,
    };
    this.$store.dispatch("swWorkerInitialized", routeData);
    this.cacheId();
  },
  computed: {
    bidPlacedAt: function () {
      return moment(
        this.demandDetails.value.bid_placed_at || new Date()
      ).fromNow();
    },
    vehicleDetail: function () {
      return (
        this.demandDetails.value.trucks_required +
        " x " +
        this.demandDetails.value.truck_type
      );
    },
    biddingprice: {
      get: function () {
        if (this.isInputActive) {
          return this.rate_received.toString();
        } else {
          return this.formatPrice(this.rate_received);
        }
      },
      set: function (modifiedValue) {
        let newValue = parseFloat(modifiedValue);
        if (isNaN(newValue)) {
          newValue = 0;
        }
        this.rate_received = newValue;
      },
    },
    totalPrice() {
      const totalPrice = this.rate_received * this.vehicle_qty;
      return this.formatPrice(totalPrice);
    },
    reportingTime() {
      return this.demandDetails.value.expected_reporting_date;
    },
  },
  methods: {
    truckAvailability() {
      this.trackMixpanelEvent(
        config.MIXPANEL_EVENTS.ON_CLICK_TRUCK_AVAILABILITY
      );
      this.$router.push(
        `/${this.$route.params.lang}/truck_availability/${this.$route.params.id}`
      );
    },
    formatPrice(price) {
      if (price !== "")
        return (
          "₹ " + price.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
        );
      else return "₹ ";
    },
    async getDemadDetails() {
      this.showPageLoader = true;
      try {
        const { data } = await axios.get(
          `${API_BASE_URL}/demand/details/${this.$route.params.id}`
        );

        this.demandDetails = data;
        this.$store.commit("updateDemandDetails", data);
        // this.editMode = data.value.demand_status_details.is_edit_allowed
        // this.editMode = false
        this.vehicle_qty = data.value.trucks_required || 0;
        if (data.value.demand_status_details.is_edit_allowed) {
          this.rate_received =
            data.value.demand_status_details.lowest_bid.rate -
              this.stepperValue || 0;
        } else {
          this.rate_received = data.value.rate || 0;
        }

        identify(data.value.supplier_id);

        const {
          supplier_name,
          contact,
          demand_id,
          status,
          supplier_id,
          user_type,
          demand_status,
        } = data.value;
        //
        const mx_prop = {
          user_type: user_type,
          user_name: supplier_name,
          phone_number: contact,
          language: this.$route.params.lang,
          demand_id: demand_id,
          demand_status: demand_status,
          bid_status: status,
          time: new Date().getTime(),
          user_id: supplier_id,
          page_src: this.$route.name,
          vehicle_count: this.vehicle_qty,
          template: this.$route.params.template || "",
        };
        MX_TRACK(config.MIXPANEL_EVENTS.PAGE_LOAD, mx_prop);
        this.trackMixpanelEvent("SET_TRUCK_QUANTITY", {
          QTY: data.value.trucks_required,
        });
        Hotjar.IDENTIFY_FO_APP(this, supplier_id, mx_prop);
      } catch (error) {
        if (
          error &&
          error.response &&
          error.response.data &&
          !error.response.data.status
        ) {
          this.$router.push("/404");
        }
      }
      this.showPageLoader = false;
    },
    async submitBid() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.showPlaceBidLoader = true;
        const reqData = {
          rate_received: this.rate_received,
          vehicle_qty: this.vehicle_qty,
        };
        try {
          const reqUrl = this.editMode
            ? `${API_BASE_URL}/bid/edit/${this.$route.params.id}`
            : `${API_BASE_URL}/bid/place/${this.$route.params.id}`;
          const { data } = await axios.post(reqUrl, reqData);
          if (data.success) {
            this.getDemadDetails();
            this.bidPlaced = true;
            this.editMode = false;
            this.$v.$reset();

            //
            const { supplier_id, demand_id } = this.demandDetails.value;
            let eventName = "";
            let mx_prop = {};
            if (this.editMode) {
              eventName = config.MIXPANEL_EVENTS.EDIT_BID_ON_SUBMIT_UPDATE_RATE;
              mx_prop = {
                original_bid:
                  this.demandDetails.value.demand_status_details.rate,
                previous_bid:
                  this.demandDetails.value.demand_status_details.rate,
                lowest_bid:
                  this.demandDetails.value.demand_status_details.lowest_bid
                    .rate,
                new_bid: this.rate_received,
                bid_value_difference:
                  this.rate_received -
                  this.demandDetails.value.demand_status_details.rate,
              };
            } else {
              eventName = config.MIXPANEL_EVENTS.SUBMIT_RATE;
              mx_prop = {
                freight_value: this.rate_received,
                vehicle_count: this.vehicle_qty,
                time: new Date().getTime(),
                user_id: supplier_id,
                page_src: this.$route.name,
                language: this.$route.params.lang,
                demand_id: demand_id,
              };
            }

            this.trackMixpanelEvent(eventName, mx_prop);
          }
        } catch (error) {
          // TODO
        }
        this.showPlaceBidLoader = false;
      }
    },
    async linkOpened() {
      try {
        await axios.patch(
          `${API_BASE_URL}/bid/open/${this.$route.params.id}`,
          null
        );
      } catch (error) {
        //TODO:
      }
    },
    enableEditBidOption() {
      this.editMode = true;
      const mx_prop = {
        original_bid: this.demandDetails.value.demand_status_details.rate,
        previous_bid: this.demandDetails.value.demand_status_details.rate,
        lowest_bid:
          this.demandDetails.value.demand_status_details.lowest_bid.rate,
        demand_status: this.demandDetails.value.demand_status_details.status,
      };
      this.trackMixpanelEvent(
        config.MIXPANEL_EVENTS.EDIT_BID_ON_CLICK_EDIT_RATE_BUTTON,
        mx_prop
      );
    },
    cancelEdit() {
      this.$v.$reset();
      this.rate_received = this.demandDetails.value.rate;
      this.editMode = false;
    },
    handleChangePrice(type) {
      this.rate_received =
        type == "increment"
          ? parseInt(this.rate_received) + this.stepperValue
          : parseInt(this.rate_received) - this.stepperValue;
      const stepperCount = this.stepperCount;
      let eventName = "";
      if (type == "increment") {
        stepperCount.up = stepperCount.up + 1;
        eventName = config.MIXPANEL_EVENTS.EDIT_BID_ON_STEPPER_UP;
      } else {
        stepperCount.down = stepperCount.down + 1;
        eventName = config.MIXPANEL_EVENTS.EDIT_BID_ON_STEPPER_DOWN;
      }
      this.stepperCount = stepperCount;
      const mx_prop = {
        original_bid: this.demandDetails.value.demand_status_details.rate,
        previous_bid: this.demandDetails.value.demand_status_details.rate,
        lowest_bid:
          this.demandDetails.value.demand_status_details.lowest_bid.rate,
        demand_status: this.demandDetails.value.demand_status_details.status,
        stepper_up_count: this.stepperCount.up,
        stepper_down_count: this.stepperCount.down,
        stepper_value_amount: this.stepperValue,
      };

      this.trackMixpanelEvent(eventName, mx_prop);
    },
    onClickInputQty() {
      this.trackMixpanelEvent("ON_CLICK_QUANTITY", { QTY: this.vehicle_qty });
    },
    trackMixpanelEvent(event, data = {}) {
      const demandDetails = this.$store.getters.getDemandDetails.value;
      const mx_prop = {
        user_type: demandDetails.user_type,
        user_name: demandDetails.supplier_name,
        phone_number: demandDetails.contact,
        language: this.$route.params.lang,
        demand_id: demandDetails.demand_id,
        demand_status: "",
        bid_status: demandDetails.status,
      };
      MX_TRACK(event, { ...mx_prop, ...data });
    },
    navigateToLoadMore() {
      this.trackMixpanelEvent(config.MIXPANEL_EVENTS.ON_CLICK_ON_LOAD_MORE);

      this.$router.push(
        `/${this.$route.params.lang}/load_market/${this.$route.params.id}`
      );
    },
    cacheId() {
      localStorage.setItem("demand_supply_id", this.$route.params.id);
    },
  },
};
</script>

<style lang="scss">
body {
  background-color: #fff !important;
}

.demand-details {
  background-color: #fff !important;
}

.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>
